export const LtlFreightTrackingEvents = {
  BOOKING_SAVE_DRAFT: 'LTL_FREIGHT_BOOKING_SAVE_DRAFT',
  BOOKING_BOOK: 'LTL_FREIGHT_BOOKING_BOOK',
  BOOKING_DELETE: 'LTL_FREIGHT_BOOKING_DELETE',
  BOOKING_VOID: 'LTL_FREIGHT_BOOKING_VOID',
  BOOKING_CLOSE_WITHOUT_BOOKING: 'LTL_FREIGHT_BOOKING_CLOSE_WITHOUT_BOOKING',
  GET_HELP_FORM_OPENED: 'LTL_FREIGHT_GET_HELP_FORM_OPENED',
  BOOKING_FORM_OPENED: 'LTL_FREIGHT_BOOKING_FORM_OPENED',
  BROWSER_OPENED: 'LTL_FREIGHT_BROWSER_OPENED',
  BOOKING_FORM_CHANGED: 'LTL_FREIGHT_BOOKING_FORM_CHANGED',
  BROWSER_FORM_CHANGED: 'LTL_FREIGHT_BROWSER_FORM_CHANGED',
  CALC_DENSITY_CLICKED: 'LTL_FREIGHT_CALC_DENSITY_CLICKED',
  RATE_ERROR_SHOWN: 'LTL_FREIGHT_RATE_ERROR_SHOWN',
  ADD_SHIP_FROM: 'LTL_FREIGHT_ADD_SHIP_FROM',
  EXISTING_CUSTOMER_USED: 'LTL_FREIGHT_EXISTING_CUSTOMER_USED',
  EXISTING_COMMODITY_PRESET_USED: 'LTL_FREIGHT_EXISTING_COMMODITY_PRESET_USED',
  EXPORT_START: 'LTL_FREIGHT_EXPORT_START',
  PRINT_DOCUMENT: 'LTL_FREIGHT_PRINT_DOCUMENT',
  GRID_FILTER: 'LTL_FREIGHT_GRID_FILTER',
  PASTE_ADDRESS_USED: 'LTL_FREIGHT_PASTE_ADDRESS_USED',
  SAVE_LTL_DEFAULTS: 'LTL_FREIGHT_SAVE_LTL_DEFAULTS',
  SHIPPING_MODE_CHANGED: 'LTL_FREIGHT_SHIPPING_MODE_CHANGED',
  SAVE_LTL_DELIVERY_DEFAULTS: 'LTL_FREIGHT_SAVE_LTL_DELIVERY_DEFAULTS',
  RATES_RECEIVED: 'LTL_FREIGHT_RATES_RECEIVED',
} as const;

export type LtlFreightBookingSource = 'from_order' | 'from_freight' | 'from_browse_rates';

export const ShippingMode = {
  Freight: 'freight',
  Parcel: 'parcel',
} as const;

export type ShippingMode = (typeof ShippingMode)[keyof typeof ShippingMode];

export const ShippingModeChangeScope = {
  Single: 'single',
  Bulk: 'bulk',
} as const;

export type ShippingModeChangeScope = (typeof ShippingModeChangeScope)[keyof typeof ShippingModeChangeScope];

export const GetHelpDestination = {
  SierraChat: 'sierra_chat',
  ZendeskForm: 'zendesk_form',
} as const;

export type GetHelpDestination = (typeof GetHelpDestination)[keyof typeof GetHelpDestination];
